/*
  KÜPSISE-EELISTUSTE VAIKELINNUKESED — 01.09.2026, muudetud 03.09.2026.

  Klient: „kõik peale turunduse peaks vaikesätetes aktiivsed olema", täpsustusega
  ekraanipildilt: linnuke on ees, aga kasutaja saab selle soovi korral eemaldada.

  MIDA SEE MUUDAB JA MIDA MITTE. Shopify „Halda eelistusi" modaal avab kõik neli
  kastikest linnukesega. See on AINULT UI seis — tegelikku nõusolekut ei ole enne,
  kui kasutaja vajutab nuppu (mõõdetud: `currentVisitorConsent()` tagastab enne
  valikut `{marketing:"", analytics:"", preferences:"", sale_of_data:""}`). Siin
  failis ei salvestata ega lubata ühtegi küpsist; „Turundus" ja „Analüütika"
  avatakse tühjana, nii et kes vajutab „Salvesta valikud" ilma midagi puutumata,
  ei anna kummalegi nõusolekut.

  KUIDAS. Kastikese `checked` otse seadmine ei uuenda Shopify enda ikoone (kaks
  SVG-d, mida ta `display`-ga vahetab), seega klõpsame `label`-i — see läbib
  Shopify oma käsitleja ja jätab komponendi terveks.

  SKRIPT SEAB SEISU, MITTE EI EEMALDA ÜHT LINNUKEST — ja see vahe on kallis.
  Esimene versioon (01.09 hommik) ainult klõpsas „Turunduse" maha, eeldusel et
  Shopify avab modaali kõigi linnukestega ees. Nii ta dev-serveril käitubki, aga
  PÄRIS POES avaneb ta kõigi kastidega TÜHJANA — mõõdetud live'is 01.09, kõik
  neli valikut tühjad. Seal ei olnud skriptil midagi maha võtta ja muudatus ei
  paistnud üldse. Nüüd käiakse kõik kolm valikut läbi ja viiakse soovitud
  seisu, ükskõik kummalt poolt alustades. Mõõdetud: „Salvesta valikud"
  loeb seisu INPUTIDEST, mitte dialoogi `data-consent` atribuudist (mis jääb
  „111"-ks), seega see võte tõesti muudab salvestatavat tulemust — kontrollitud
  01.09.2026 dev-serveril, tulemus tollase seadistusega `{marketing:"no",
  analytics:"yes", preferences:"yes"}`. Sama võte, uus soovitud seis
  (03.09) annab `analytics:"no"` — mehhanism ei muutunud, ainult tabel.

  MILLAL MITTE. Kui külastajal on juba varasem valik, ei puutu me midagi — muidu
  kirjutaksime tema enda „turundus: jah" iga avamisega üle.

  NB juriidiline märkus, teadlikult nii tellitud: eelmärgitud linnukesed
  analüütikale ja isikupärastamisele on GDPR/EDPB juhise järgi ise küsitavad
  (nõusolek peab olema aktiivne tegevus).

  „ANALÜÜTIKA" KASTIKE AVATI TÜHJANA 3.09.2026 — ja see EI OLE kliendi
  1.09 otsuse tühistamine, vaid selle otsuse aluse kadumine. Otsus („kõik
  peale turunduse peaks vaikesätetes aktiivsed olema") tehti ajal, kui saidil
  ei olnud ühtegi trackerit ja eelmärgitud kastike ei käivitanud MIDAGI.
  31.08 lisandus GA4 (`G-SL4862CKFB`) ja hakkas sõltuma OTSE sellest
  kastikesest: `analytics_storage` läks „granted" peale ja `_ga` küpsis pandi
  ära, kui külastaja vajutas „Salvesta valikud" ilma midagi puutumata. Ehk
  analüütikanõusolek oli kaks päeva VAIKIMISI JAH, ilma aktiivse tegevuseta —
  täpselt see, mida EDPB juhis 05/2020 keelab.

  MIS SELLEST JÄRELDUB JA MIS MITTE. Kastike ei ole ainus kaitse: teema
  `snippets/tracking-scripts.liquid` loeb päris nõusolekut `customerPrivacy`
  API-st ja Consent Mode vaikeväärtus on „denied", seega GA4 ei pannud küpsist
  enne, kui külastaja nupu vajutas. Probleem oli selles, mida see nupp
  vaikimisi TÄHENDAS, mitte selles, et gate puudus.

  „Eelistused" jäi ette. Tema taga ei ole ühtegi teenust, seega eelmärgitud
  kastike ei käivita seal andmetöötlust ja kliendi otsus kehtib edasi.
  Turundus oli ja jääb tühi — Meta Pixel ei laadi `fbevents.js`'i enne päris
  nõusolekut.

  REEGEL EDASPIDISEKS: eelmärgitud kastike on lubatav ainult seni, kuni tema
  taga ei ole midagi. Iga uus tracker tuleb siin läbi vaadata SAMAL PÄEVAL,
  koos küpsiste poliitikaga. Vt CLAUDE.md „Cookie Policy" ja mälu
  `cookie_banner_tracker_consent_wiring`.
*/
(function () {
  'use strict';

  /* Soovitud vaikeseis. Kliendi otsus 01.09.2026 oli „kõik ees peale
     turunduse"; „Analüütika" viidi 03.09.2026 tühjaks, kui GA4 tema taha
     jõudis — vt päise selgitust. „Eelistused" jääb ette: tema taga ei ole
     ühtegi teenust, seega eelmärgitud kastike ei käivita andmetöötlust ja
     kliendi otsus kehtib seal edasi. */
  var SOOVITUD = {
    'shopify-pc__prefs__preferences-input': true,
    'shopify-pc__prefs__marketing-input': false,
    'shopify-pc__prefs__analytics-input': false,
  };

  /* Jaluse link „Küpsiste seaded". Ilma selleta ei saa nõusolekut ÜLDSE muuta:
     kui külastaja on korra vajutanud, on riba selles brauseris kadunud ja
     modaali ei ava enam miski. GDPR ootab, et tagasivõtmine oleks sama lihtne
     kui nõustumine.

     Link on tavaline `footer_link` plokk (`sections/footer-group.json`,
     link-12) aadressiga `#kupsiste-seaded`, mitte omaette sektsiooniseade —
     nii saab klient teda teema editoris ümber nimetada või mujale tõsta ja
     me ei pidanud jaluse skeemi puutuma.

     Avamiseks on `window.privacyBanner.showPreferences()`. NB:
     `Shopify.customerPrivacy` peal seda meetodit EI OLE (kontrollitud
     01.09.2026 — tal on ainult get/set-tüüpi meetodid), see elab eraldi
     `privacyBanner` globaalil. */
  var LINGI_SIHT = '#kupsiste-seaded';

  var tehtud = false;

  function onVarasemValik() {
    try {
      var c = window.Shopify.customerPrivacy.currentVisitorConsent();
      return !!(c && (c.marketing || c.analytics || c.preferences));
    } catch (e) {
      // Kui API-t ei ole, ei ole ka nõusolekut salvestatud.
      return false;
    }
  }

  function seaVaikimisi() {
    if (tehtud || onVarasemValik()) return;

    var leitud = false;

    // Modaal viib avanedes fookuse sulgemisnupule; `label.click()` tõmbaks
    // selle kastikesele ja klaviatuurikasutaja alustaks poole dialoogi pealt.
    var fookus = document.activeElement;

    Object.keys(SOOVITUD).forEach(function (id) {
      var input = document.getElementById(id);
      if (!input) return;

      leitud = true;
      if (input.checked === SOOVITUD[id]) return;

      var label = document.querySelector('label[for="' + id + '"]');
      if (label) label.click();
    });

    if (!leitud) return;

    if (fookus && typeof fookus.focus === 'function') fookus.focus();
    tehtud = true;
  }

  function jalgi() {
    var juur = document.getElementById('shopify-pc__prefs');

    if (juur) {
      seaVaikimisi();
      // Modaali ei eemaldata DOM-ist, vaid peidetakse `style="display:none"`,
      // seega jälgime atribuuti, mitte lisamist.
      new MutationObserver(seaVaikimisi).observe(juur, {
        attributes: true,
        attributeFilter: ['style'],
      });
      return true;
    }

    return false;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href$="' + LINGI_SIHT + '"]') : null;
    if (!link) return;

    e.preventDefault();

    try {
      window.privacyBanner.showPreferences();
    } catch (err) {
      // Kui bänneri API-t ei ole (nt riba on Shopify seadetes välja lülitatud),
      // ei tee link midagi — parem kui viga konsoolis.
    }
  });

  if (!jalgi()) {
    // Shopify lisab modaali alles siis, kui riba on laetud.
    var vaatleja = new MutationObserver(function () {
      if (jalgi()) vaatleja.disconnect();
    });
    vaatleja.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
